exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modalLessonSelection fieldset{border:1px solid rgba(0,116,217,.3803921568627451)!important;border-radius:5px}#modalLessonSelection fieldset legend{color:rgba(0,112,214,.6705882352941176)!important}#modalLessonSelection .custom-tooltip .tooltip-inner{min-width:420px;padding-bottom:15px}#modalLessonSelection .modal-header .modal-title{font-size:15px;text-align:center;width:100%}#modalLessonSelection .image .img-thumbnail{width:300px}.hidden_header{display:none}", ""]);

// exports
